import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

// Minimální zásoba (§7) — jedno číslo, 0 = vypnout hlídání.
export function MinQtyDialog({ item, busy, onSubmit, onClose }) {
  const [qty, setQty] = useState(item.min_qty || 0);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto" data-testid="minqty-dialog">
        <DialogHeader><DialogTitle>Minimální zásoba — {item.name}</DialogTitle></DialogHeader>
        <div className="space-y-3.5">
          <div>
            <Label>Minimální zásoba (0 = vypnout hlídání) ({item.unit})</Label>
            <Input type="number" step="0.001" value={qty} onChange={(e) => setQty(e.target.value)} className="h-11 mt-1 w-full min-w-0" data-testid="minqty-input" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" className="w-full md:w-auto" onClick={onClose}>Zrušit</Button>
          <Button className="w-full md:w-auto" onClick={() => onSubmit({ min_qty: qty })} disabled={busy} data-testid="minqty-confirm">
            {busy ? "Ukládám…" : "Uložit"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
